document.addEventListener("DOMContentLoaded", () => {
    let flickityInstances = [];

    const initializeFlickity = (elemSlider) => {
        const flickityInstance = new Flickity(elemSlider, {
            freeScroll: true,
            wrapAround: true,
            draggable: false,
            contain: true,
            resize: true
        });
        flickityInstances.push(flickityInstance);
    };

    const destroyFlickity = () => {
        flickityInstances.forEach((instance) => {
            instance.destroy();
        });
        flickityInstances = [];
    };

    const handleResize = () => {
        const windowWidth = window.innerWidth;
        if (windowWidth < 900) {
            destroyFlickity();
        } else {
            const elemSliders = document.querySelectorAll('.image_carousel');
            elemSliders.forEach((elemSlider) => {
                if (!flickityInstances.some((instance) => instance.element === elemSlider)) {
                    initializeFlickity(elemSlider);
                }
            });
        }
    };

    handleResize(); // Initial setup
    window.addEventListener('resize', handleResize);
});
